const emailPattern = `([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+`; // https://stackoverflow.com/a/14075810
const emailRegex = new RegExp(emailPattern);

export const verdictKeys = {
  undefined: 0,
  valid: 1,
  risky: 2,
  invalid: 3,
};

export function validateEmail(email) {
  return email && emailRegex.test(email);
}

export async function validateEmailWithApi(email, api) {
  if (!email) {
    return { isValid: false };
  }

  if (email.includes("_@") || email.includes("__")) {
    // SendGrid Email validation considers this an invalid email ex: abc_@hotmail.com.
    // But apparently it is valid. So we will just do a simple regex validation then.
    return {
      isValid: validateEmail(email),
    };
  }

  const dto = {
    email,
    source: "ePortWebGui", // TODO
  };

  const result = await api.fetch(`${import.meta.env.VITE_MAIN_URL}actors/validate/email`, dto, "POST");
  if (!result || !result.isSuccessful) {
    return result;
  }

  const { verdict, hasValidAddressSyntax, hasMXAndOrARecordPresent, hasKnownBounces, hasSuspectedBounces, suggestion } =
    result;

  return {
    isValid: isValidEmail(verdict, hasKnownBounces),
    validationErrorTranslationKey: getValidationErrorMessageTranslationKey(
      verdict,
      hasValidAddressSyntax,
      hasMXAndOrARecordPresent,
      hasKnownBounces,
      hasSuspectedBounces
    ),
    suggestion,
  };
}

function isValidEmail(verdict, hasKnownBounces) {
  // We don't consider invalid/blocking if hasKnownBounces
  if (verdict === verdictKeys.invalid && !hasKnownBounces) {
    return false;
  } else {
    return true;
  }
}

function getValidationErrorMessageTranslationKey(
  verdict,
  hasValidAddressSyntax,
  hasMXAndOrARecordPresent,
  hasKnownBounces,
  hasSuspectedBounces
) {
  if (verdict === verdictKeys.invalid) {
    if (!hasValidAddressSyntax) {
      return "NoValidAddressSyntax";
    } else if (!hasMXAndOrARecordPresent) {
      return "HasNoMxAndOrARecordPresent";
    } else if (hasKnownBounces) {
      return "HasKnownBounces";
    } else {
      return "InvalidEmail";
    }
  } else if (verdict === verdictKeys.risky) {
    if (hasSuspectedBounces) {
      return "HasSuspectedBounces";
    } else {
      return "RiskyEmail";
    }
  } else {
    return null;
  }
}
